export const saveUrlForRedirect = (urlHash, testHistory) => {
  if (testHistory && window.history.length > 3) {
    return;
  }
  localStorage.setItem('urlForRedirect', urlHash);
};

export const redirectToSavedUrl = clearAfterRedirect => {
  const savedURL = localStorage.getItem('urlForRedirect');

  if (clearAfterRedirect) {
    localStorage.removeItem('urlForRedirect');
  }

  if (savedURL.indexOf('#') !== -1) {
    window.location.href = savedURL;
  } else {
    window.location.hash(savedURL);
  }
};

export const getSavedUrl = clear => {
  const savedURL = localStorage.getItem('urlForRedirect') || '#/';

  if (clear) {
    localStorage.removeItem('urlForRedirect');
  }

  return savedURL;
};

export const removeSavedUrl = () => {
  localStorage.removeItem('urlForRedirect');
};

export const isUrlSaved = () => !!localStorage.getItem('urlForRedirect');
